// src/data/members.js
import brian_hor from '../images/brian-hor.jpeg'
import hor3 from '../images/hor-3.jpeg'
import JJ_hor from '../images/JJ-hor.jpeg'
import klausner_hor from '../images/klausner-hor.jpeg'
import nolan_hor from '../images/nolan-hor.jpeg'
import vert1 from '../images/vert-1.jpeg'
import vert11 from '../images/vert-11.jpeg'
import vert12 from '../images/vert-12.jpeg'
import vert3 from '../images/vert-3.jpeg'
import vert6 from '../images/vert-6.jpeg'
// TODO: Import Andy's photos here, e.g.:
import andy_hor from '../images/andy-hor.jpeg'
import andy_vert from '../images/andy-vert-2.jpeg'

export const members = [
  {
    slug: 'jake-klausner',
    name: 'Jake Klausner',
    role: 'Lead Guitar',
    image: vert3,
    bgImage: klausner_hor,
    bio: `Jake Klausner grew up in Columbus, Ohio, where his early love for music met a lifelong obsession with guitar. Picking up the instrument at 17, he dove headfirst into blues and rock, teaching himself the language of classic players like Jimi Hendrix and John Frusciante. That foundation shaped his expressive, riff-driven lead style that now fuels Koda's live energy. Outside the band, Jake is a biomedical engineer by day and a relentless creative by night—splitting time between research, songwriting, and refining his tone. `,
  },
  {
    slug: 'jackson-buss',
    name: 'Jackson Buss',
    role: 'Rhythm Guitar & Keys',
    image: vert12,
    bgImage: hor3,
    bio: `Jackson Buss discovered his passion for music at a young age, inspired by his father, who owned a chain of record stores in his youth. Surrounded by timeless and modern records growing up, Jackson spent countless hours learning the piano before eventually picking up the guitar.
    
    Throughout school, he jammed with close friends in basements, backyards, and dorm rooms—spaces where the foundation of KODA was first built alongside Brewer and Klausner through a shared love of music. As the band grew, Jackson continued honing his craft, becoming a key contributor on both guitar and piano. His sound is heavily influenced by the grit of southern rock and the soul of the blues, bringing energy and emotion to every track.
    
    When he's not on stage or in the studio, you'll likely find him behind the wheel of the "KODA Bus," keeping the band rolling down the road. Off the road, Jackson enjoys collecting vinyl records and spending time with his family on their cattle farm.`,
  },
  {
    slug: 'andy-hanna',
    name: 'Andy Hanna',
    role: 'Bass Guitar',
    image: andy_vert,
    bgImage: andy_hor,
    bio: `Andy Hanna is a talented bassist renowned for his groovy style, extensive knowledge of scales and music theory, and precise rhythmic execution. Growing up, he was exposed to a wide range of genres, including classic rock, delta blues, alternative and indie rock, and rap. This diverse background heavily contributes to his unique playing style, which blends elements of each genre into his playing style.

Andy's journey with music began at age 8, when he first picked up the acoustic guitar. In learning to play, Andy fell in love with music, eventually teaching himself piano and music theory as his journey progressed. A lead guitarist in many bands, it wasn’t until he joined KODA that he first played bass in a group setting.

In KODA, Andy's bass lines provide the backbone for the band's sound, driving the music forward and adding depth and unique rhythm to each song. As a songwriter, he takes great inspiration from bassists like the Beatles’ Paul McCartney and RHCP’s Flea, and his creative approach to songwriting and arrangement has also made him an invaluable member of the group.

Outside of music, Andy enjoys playing hockey, hiking, watching movies, cooking, and spending time with his family and friends. He believes that life is all about balance, and he strives to bring that philosophy into his music as well.`,
  },
  {
    slug: 'brian-foster',
    name: 'Brian Foster',
    role: 'Drums',
    image: vert6,
    bgImage: brian_hor,
    bio: `Brian started playing drums in first grade. By high school, he was president of the marching band and section leader of the jazz band—blending those early skills with a love for rock that drives his playing in KODA.

A Cleveland native, Brian graduated from The Ohio State University in May 2025 with a degree in Computer Science and a minor in Mathematics.

Outside of drumming, he's into lifting, the outdoors, and discovering new music. He also built this entire website to help share KODA's story.`,
  },
  {
    slug: 'jake-juenger',
    name: 'Jake Juenger',
    role: 'Vocals',
    image: vert11,
    bgImage: JJ_hor,
    bio: `Jake has been singing and playing music for as long as he can remember. He grew up singing in church as a child and joined his first choir in the 5th grade. He started taking piano lessons in 4th grade and sang in several other auditioned choirs throughout middle school. 
    
    In high school he joined Parkway West High's esteemed Jazz choir along with vocalist Nolan Barbre where they learned under Brian Parrish, who they both hold in extremely high regard for his teaching and playing abilities. In college, Jake joined Miami University's premier mens a capella group, Soul2Soul. While in college, Juenger met Buss, Klausner and Brewer at a halloween party his freshman year. Several months later, him and Buss, then a Miami student, reconnected and began jamming together in dorm rooms before Buss invited him to join the group.
    
    While still in school, Juenger would drive from Oxford to Columbus to play shows on the weekends before eventually moving back home to St Louis, where he continued to put miles on his car driving 6 hours instead of 2 for gigs. Juenger finally decided to move to Columbus to be closer to the group and is slowly settling into calling Ohio his new home. `,
  },
  {
    slug: 'nolan-barbre',
    name: 'Nolan Barbre',
    role: 'Vocals',
    image: vert1,
    bgImage: nolan_hor,
    bio: `For Nolan, music started with lullabies and Beatle's music in the crib. After singing in church as child, he joined choir in 5th grade with co-lead Jake Juenger. It wasn't until he found a Snoop Dogg CD in his father's car that discovered that music could be audacious, mysterious, and most importantly, fun. Moving forward discovering numerous musical influences from all points in time, he finds the most inspiration from acts like Queen, James Brown, Prince, Elton John, Kendrick Lamar, and Michael Jackson.

    After going to school at Missouri State for music education and theory studies, Nolan chose to leave school and work full time. You can catch him at Valvoline during the day, but outside of work he continues to immerse himself in new music, constantly learning and figuring out how to make the next performance and explosion of emotion.`,
  },
]
